export const toAbsoluteUrl = (pathname: string) => import.meta.env.VITE_PUBLIC_URL + pathname;
